<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_4">
<p class="calibre7"><span id="Page_vii" title="[Pg vii]"></span></p>
<h2 class="nobreak" id="pgepubid00001">CONTENTS</h2>
</div>
<table class="calibre12" summary="">
<tbody class="calibre13"><tr class="calibre14">
<td class="tdr">CHAPTER</td>
<td class="tdl"></td>
<td class="tdr">PAGE</td>
</tr>
<tr class="calibre14">
<td class="tdr">I.  </td>
<td class="tdl">PATIENCE ON A GATE,</td>
<td class="tdr"><a href="#/Text/Section0003#CHAPTER_I">1</a></td>
</tr>
<tr class="calibre14">
<td class="tdr">II.  </td>
<td class="tdl">IN THE VERANDAH,</td>
<td class="tdr"><a href="#/Text/Section0004#CHAPTER_II">10</a></td>
</tr>
<tr class="calibre14">
<td class="tdr">III.  </td>
<td class="tdl">AN EARLY VISIT,</td>
<td class="tdr"><a href="#/Text/Section0005#CHAPTER_III">19</a></td>
</tr>
<tr class="calibre14">
<td class="tdr">IV.  </td>
<td class="tdl">ANGEL IN EXCELSIS,</td>
<td class="tdr"><a href="#/Text/Section0006#CHAPTER_IV">27</a></td>
</tr>
<tr class="calibre14">
<td class="tdr">V.  </td>
<td class="tdl"> THE LUCKNOW ROAD,</td>
<td class="tdr"><a href="#/Text/Section0007#CHAPTER_V">34</a></td>
</tr>
<tr class="calibre14">
<td class="tdr">VI.  </td>
<td class="tdl">LATE FOR MESS,</td>
<td class="tdr"><a href="#/Text/Section0008#CHAPTER_VI">42</a></td>
</tr>
<tr class="calibre14">
<td class="tdr">VII.  </td>
<td class="tdl">MRS. DAWSON'S DRESSES,</td>
<td class="tdr"><a href="#/Text/Section0009#CHAPTER_VII">48</a></td>
</tr>
<tr class="calibre14">
<td class="tdr">VIII.  </td>
<td class="tdl">THE PICNIC,</td>
<td class="tdr"><span href="#/Text/Section0010#CHAPTER_VIII" title="Link target outside of Sample">58</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">IX.  </td>
<td class="tdl">THE BEQUEST,</td>
<td class="tdr"><span href="#/Text/Section0011#CHAPTER_IX" title="Link target outside of Sample">66</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">X.  </td>
<td class="tdl">A CHALLENGE,</td>
<td class="tdr"><span href="#/Text/Section0012#CHAPTER_X" title="Link target outside of Sample">78</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XI.  </td>
<td class="tdl">WHO IS SHE?</td>
<td class="tdr"><span href="#/Text/Section0013#CHAPTER_XI" title="Link target outside of Sample">92</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XII.  </td>
<td class="tdl">ANGEL IMPARTS A SECRET,</td>
<td class="tdr"><span href="#/Text/Section0014#CHAPTER_XII" title="Link target outside of Sample">98</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XIII.  </td>
<td class="tdl">ANGEL'S WINGS ARE CLIPPED,</td>
<td class="tdr"><span href="#/Text/Section0015#CHAPTER_XIII" title="Link target outside of Sample">105</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XIV.  </td>
<td class="tdl">PHILIP'S LOVE AFFAIR,</td>
<td class="tdr"><span href="#/Text/Section0016#CHAPTER_XIV" title="Link target outside of Sample">115</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XV.  </td>
<td class="tdl">LOLA,</td>
<td class="tdr"><span href="#/Text/Section0017#CHAPTER_XV" title="Link target outside of Sample">126</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XVI.  </td>
<td class="tdl">GRANDMAMMA,</td>
<td class="tdr"><span href="#/Text/Section0018#CHAPTER_XVI" title="Link target outside of Sample">134</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XVII.  </td>
<td class="tdl">THE UNEXPECTED,</td>
<td class="tdr"><span href="#/Text/Section0019#CHAPTER_XVII" title="Link target outside of Sample">146</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XVIII.  </td>
<td class="tdl">DINNER FOR TWO,</td>
<td class="tdr"><span href="#/Text/Section0020#CHAPTER_XVIII" title="Link target outside of Sample">159</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XIX.  </td>
<td class="tdl">THE PARTING GUESTS,</td>
<td class="tdr"><span href="#/Text/Section0021#CHAPTER_XIX" title="Link target outside of Sample">175</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XX.  </td>
<td class="tdl">A DESTROYING ANGEL,</td>
<td class="tdr"><span href="#/Text/Section0022#CHAPTER_XX" title="Link target outside of Sample">183</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXI.  </td>
<td class="tdl">"THINK IT OVER,"</td>
<td class="tdr"><span href="#/Text/Section0023#CHAPTER_XXI" title="Link target outside of Sample">193</span><span id="pgepubid00002" title="[Pg viii]"></span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXII.  </td>
<td class="tdl">"A WHITE ELEPHANT AND A WHITE ROSE,"</td>
<td class="tdr"><span href="#/Text/Section0024#CHAPTER_XXII" title="Link target outside of Sample">209</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXIII.  </td>
<td class="tdl">ANGEL DECLINES A PENNY FOR HER THOUGHTS,</td>
<td class="tdr"><span href="#/Text/Section0025#CHAPTER_XXIII" title="Link target outside of Sample">217</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXIV.  </td>
<td class="tdl">THE SOOTHSAYER,</td>
<td class="tdr"><span href="#/Text/Section0026#CHAPTER_XXIV" title="Link target outside of Sample">228</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXV.  </td>
<td class="tdl">THE CHITACHAR CLUB,</td>
<td class="tdr"><span href="#/Text/Section0027#CHAPTER_XXV" title="Link target outside of Sample">239</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXVI.  </td>
<td class="tdl">IN ANGEL'S TENT,</td>
<td class="tdr"><span href="#/Text/Section0028#CHAPTER_XXVI" title="Link target outside of Sample">255</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXVII.  </td>
<td class="tdl">"THE SIN,"</td>
<td class="tdr"><span href="#/Text/Section0029#CHAPTER_XXVII" title="Link target outside of Sample">266</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXVIII.  </td>
<td class="tdl">MAKING FRIENDS,</td>
<td class="tdr"><span href="#/Text/Section0030#CHAPTER_XXVIII" title="Link target outside of Sample">277</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXIX.  </td>
<td class="tdl">LAST YEAR'S NEST,</td>
<td class="tdr"><span href="#/Text/Section0031#CHAPTER_XXIX" title="Link target outside of Sample">286</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXX.  </td>
<td class="tdl">A WHITED SEPULCHRE,</td>
<td class="tdr"><span href="#/Text/Section0032#CHAPTER_XXX" title="Link target outside of Sample">291</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXXI.  </td>
<td class="tdl">FISHING FOR AN INVITATION,</td>
<td class="tdr"><span href="#/Text/Section0033#CHAPTER_XXXI" title="Link target outside of Sample">296</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXXII.  </td>
<td class="tdl">BY PROXY,</td>
<td class="tdr"><span href="#/Text/Section0034#CHAPTER_XXXII" title="Link target outside of Sample">303</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXXIII.  </td>
<td class="tdl">EXPLANATION,</td>
<td class="tdr"><span href="#/Text/Section0035#CHAPTER_XXXIII" title="Link target outside of Sample">313</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXXIV.  </td>
<td class="tdl">A REFUGEE,</td>
<td class="tdr"><span href="#/Text/Section0036#CHAPTER_XXXIV" title="Link target outside of Sample">320</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXXV.  </td>
<td class="tdl">A GOOD BILLET,</td>
<td class="tdr"><span href="#/Text/Section0037#CHAPTER_XXXV" title="Link target outside of Sample">330</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXXVI.  </td>
<td class="tdl">JOINT HOSTESS,</td>
<td class="tdr"><span href="#/Text/Section0038#CHAPTER_XXXVI" title="Link target outside of Sample">337</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXXVII.  </td>
<td class="tdl">IN GARHWAL,</td>
<td class="tdr"><span href="#/Text/Section0039#CHAPTER_XXXVII" title="Link target outside of Sample">344</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXXVIII.  </td>
<td class="tdl">INTERLOPERS,</td>
<td class="tdr"><span href="#/Text/Section0040#CHAPTER_XXXVIII" title="Link target outside of Sample">355</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XXXIX.  </td>
<td class="tdl">TO DIE WITH YOU,</td>
<td class="tdr"><span href="#/Text/Section0041#CHAPTER_XXXIX" title="Link target outside of Sample">365</span></td>
</tr>
<tr class="calibre14">
<td class="tdr">XL.  </td>
<td class="tdl">THE INTRUDER,</td>
<td class="tdr"><span href="#/Text/Section0042#CHAPTER_XL" title="Link target outside of Sample">375</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?9103dc40